const resetPasswordPageStyles = {
  resetPasswordLabel: {
    paddingBottom: 20,
  },
}

export default resetPasswordPageStyles
